import {FaBoxes, FaTshirt, FaUser} from "react-icons/fa";
import {BiUser} from "react-icons/bi";
import {FiDownload} from "react-icons/fi";
import { FormattedMessage } from "react-intl";
import { IoBarChartOutline } from "react-icons/io5";
import { TiCloudStorage } from "react-icons/ti";
import { MdOutlineHistory } from "react-icons/md";
import { FaUsers } from "react-icons/fa";
import { REPO_HOME_PAGE_URL } from "../../constants";

export const normalLinks = [
    {
        title: <FormattedMessage id="orders" defaultMessage={"Orders"} />,
        icon: FaBoxes,
        to: "/orders"
    },
    {
        title: <FormattedMessage id="export_orders" defaultMessage={"Export Orders"} />,
        icon: FiDownload,
        to: "/export-order"
    },
    // {
    //     title: <FormattedMessage id="users" defaultMessage={"Users"} />,
    //     icon: BiUser,
    //     to: "/users"
    // },
    {
        title: <FormattedMessage id="statistics" defaultMessage={"Statistics"} />,
        icon: IoBarChartOutline,
        to: "/statistics"
    }, 
    // {
    //     title: <FormattedMessage id="history_listings" defaultMessage={"History Listings"} />,
    //     icon: MdOutlineHistory,
    //     to: "/history-listings"
    // },
    {
        title: <FormattedMessage id="clients" defaultMessage={"Clients"} />,
        icon: FaUsers,
        to: "/clients"
    },
    {
        title: <FormattedMessage id="repository" defaultMessage={"Repository"} />,
        icon: TiCloudStorage,
        to: REPO_HOME_PAGE_URL
    },
    // {
    //     title: "Home",
    //     icon: AiFillHome,
    //     to: "/"
    // },
    // {
    //     title: "Categories",
    //     icon: BiCategory,
    //     to: "/categories"
    // },
    // {
    //     title: "Add Product",
    //     icon: FaTshirt,
    //     to: "/products/add"
    // },
    // {
    //     title: "My Profile",
    //     icon: FaUser,
    //     to: "/profile"
    // },
    // {
    //     title: "Settings",
    //     icon: BiCog,
    //     links: [
    //         {
    //             title: "My Profile",
    //             icon: BiCog,
    //             to: "/profiles"
    //         },
    //     ]
        
    // },
]